import { render } from "./SurveyQuestionCreate.vue?vue&type=template&id=2f0a394a&scoped=true"
import script from "./SurveyQuestionCreate.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionCreate.vue?vue&type=script&lang=js"

import "./SurveyQuestionCreate.vue?vue&type=style&index=0&id=2f0a394a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0a394a"]])

export default __exports__